import { render, staticRenderFns } from "./goodsCategoryModal.vue?vue&type=template&id=848aa8c0&scoped=true"
import script from "./goodsCategoryModal.vue?vue&type=script&lang=js"
export * from "./goodsCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./goodsCategoryModal.vue?vue&type=style&index=0&id=848aa8c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848aa8c0",
  null
  
)

export default component.exports